<template>
	<ion-page>
		<ion-header :translucent="true">
			<ion-toolbar>
				<ion-buttons slot="start">
					<ion-menu-button color="primary"></ion-menu-button>
				</ion-buttons>
				<ion-title>Create Boat</ion-title>
			</ion-toolbar>
		</ion-header>

		<ion-content :fullscreen="true">
			<div id="container">
				<ion-segment :value="postData['operate_type']" @ionChange="segmentChanged($event)"
					class="ion-text-center" scrollable="true" style="margin:auto;" id="ionSegmentScroll">
					<ion-segment-button value="Self" class="ion-text-center" style="margin:auto;">
						<ion-label>Self</ion-label>
					</ion-segment-button>
					<ion-segment-button value="Rent" class="ion-text-center" style="margin:auto;">
						<ion-label>Rent</ion-label>
					</ion-segment-button>
				</ion-segment>
				<ion-item>
					<ion-label position="floating">Owner Name:</ion-label>
					<ion-input mode="ios" v-model="postData['owner_name']"></ion-input>
				</ion-item>
				<div v-for="(ex,j) of postData['owner_mobile']" :key="j">
					<ion-item>
						<ion-text>
							<h5>Mobile:</h5>
						</ion-text>
						<ion-button color="danger" @click="removeOwnerMobile(j)" v-if="j>0">
							Remove
						</ion-button>
					</ion-item>

					<ion-item>
						<ion-label position="floating">Owner Mobile</ion-label>
						<ion-input mode="ios" v-model="postData['owner_mobile'][j]['mobile']" type="tel"></ion-input>
					</ion-item>
				</div>
				<ion-item>
					<ion-button @click="addMoreOwnerMobile()" color="secondary">Add More Mobile</ion-button>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Owner Address</ion-label>
					<ion-input mode="ios" type="text" v-model="postData['owner_address']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Owner NID</ion-label>
					<ion-input mode="ios" type="text" v-model="postData['owner_nid']"></ion-input>
				</ion-item>

				<ion-item v-show="nidImage!=null">
					<div class="ion-text-center" style="width: 100%; margin: 10px;">
						<img v-show="nidImage!=null" :src="nidImage" style="max-width:100%;max-height:200px;">
					</div>
				</ion-item>

				<ion-item>
					<ion-button @click="takePicture('nid')" color="secondary">Add Nid Photo</ion-button>
				</ion-item>
				<ion-item v-show="ownerImage!=null">
					<div class="ion-text-center" style="width: 100%; margin: 10px;">
						<img v-show="ownerImage!=null" :src="ownerImage" style="max-width:100%;max-height:200px;">
					</div>
				</ion-item>
				<ion-item>
					<ion-button @click="takePicture('owner')" color="secondary">Add Owner Photo</ion-button>
				</ion-item>
				<div v-if="postData['operate_type'] == 'Rent'">
					<ion-item>
						<ion-label position="floating">Operator Name:</ion-label>
						<ion-input mode="ios" v-model="postData['operator_name']"></ion-input>
					</ion-item>
					<div v-for="(ex,j) of postData['operator_mobile']" :key="j">
						<ion-item>
							<ion-text>
								<h5>Mobile:</h5>
							</ion-text>
							<ion-button color="danger" @click="removeOperatorMobile(j)" v-if="j>0">
								Remove
							</ion-button>
						</ion-item>

						<ion-item>
							<ion-label position="floating">Operator Mobile</ion-label>
							<ion-input mode="ios" v-model="postData['operator_mobile'][j]['mobile']" type="tel">
							</ion-input>
						</ion-item>
					</div>
					<ion-item>
						<ion-button @click="addMoreOperatorMobile()" color="secondary">Add More Mobile</ion-button>
					</ion-item>
					<ion-item>
						<ion-label position="floating">Operator Address</ion-label>
						<ion-input mode="ios" type="text" v-model="postData['operator_address']"></ion-input>
					</ion-item>

					<ion-item>
						<ion-label position="floating">Operator NID</ion-label>
						<ion-input mode="ios" type="text" v-model="postData['operator_nid']"></ion-input>
					</ion-item>

					<ion-item v-show="operatorNidImage!=null">
						<div class="ion-text-center" style="width: 100%; margin: 10px;">
							<img v-show="operatorNidImage!=null" :src="operatorNidImage" style="max-width:100%;max-height:200px;">
						</div>
					</ion-item>

					<ion-item>
						<ion-button @click="takePicture('operatorNid')" color="secondary">Add Operator Nid Photo</ion-button>
					</ion-item>

					<ion-item v-show="operatorImage!=null">
						<div class="ion-text-center" style="width: 100%; margin: 10px;">
							<img v-show="operatorImage!=null" :src="operatorImage" style="max-width:100%;max-height:200px;">
						</div>
					</ion-item>

					<ion-item>
						<ion-button @click="takePicture('operator')" color="secondary">Add Operator Photo</ion-button>
					</ion-item>
				</div>
				<ion-item v-show="boatImage!=null">
					<div class="ion-text-center" style="width: 100%; margin: 10px;">
						<img v-show="boatImage!=null" :src="boatImage" style="max-width:100%;max-height:200px;">
					</div>
				</ion-item>
				<ion-item>
					<ion-button @click="takePicture('boat')" color="secondary">Add Boat Photo</ion-button>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Boat Type</ion-label>
					<ion-input mode="ios" type="text" v-model="postData['boat_type']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Engine </ion-label>
					<ion-select mode="ios" interface="action-sheet" v-model="postData['engine']">
						<ion-select-option value="Yes">Yes</ion-select-option>
						<ion-select-option value="No">No</ion-select-option>
					</ion-select>
				</ion-item>

				<ion-item>
					<ion-label position="floating">Ghat Location</ion-label>
					<ion-input mode="ios" v-model="location" readonly="true" disabled></ion-input>
				</ion-item>
				<ion-item>
					<ion-button @click="getGhatLocation()" color="secondary">Add Ghat Location</ion-button>
				</ion-item>

				<ion-button expand="block" @click="save()" color="primary">Save</ion-button>
			</div>
		</ion-content>
	</ion-page>
</template>

<script>
	import {
		IonButtons,
		IonButton,
		IonContent,
		IonHeader,
		IonMenuButton,
		IonPage,
		IonTitle,
		IonToolbar,
		IonInput,
		IonItem,
		IonLabel,
		IonSelect,
		IonSelectOption,
		IonText,
		IonSegment,
		IonSegmentButton,
		alertController,
		IonImg,
	} from '@ionic/vue';
	import Loading from '../Loading';
	import {
		Geolocation
	} from '@capacitor/geolocation';
	import {
		Camera,
		CameraResultType,
		CameraSource
	} from "@capacitor/camera";
	export default {
		name: 'Create Service Requisition',
		components: {
			IonButtons,
			IonButton,
			IonContent,
			IonHeader,
			IonMenuButton,
			IonPage,
			IonTitle,
			IonToolbar,
			IonInput,
			IonItem,
			IonLabel,
			IonSelect,
			IonSelectOption,
			IonText,
			IonSegment,
			IonSegmentButton,
			// IonImg,
		},
		data() {
			return {
				ownerImage: null,
				nidImage: null,
				operatorImage: null,
				operatorNidImage: null,
				boatImage: null,
				segment: 'Self',
				location: null,
				postData: {
					'owner_name': null,
					'owner_mobile': [{
						mobile: null
					}],
					'owner_address': null,
					'owner_nid': null,
					'owner_nid_picture': null,
					'owner_picture': null,
					'operator_name': null,
					'operator_mobile': [{
						mobile: null
					}],
					'operator_address': null,
					'operator_nid': null,
					'operator_nid_picture': null,
					'operator_picture': null,
					'boat_picture': null,
					'boat_type': null,
					'operate_type': 'Self',
					'engine': null,
					'ghat': {
						lat: null,
						lng: null,
					},
				}
			}
		},
		methods: {
			clearDateTime(event) {
				event.target.value = '';
			},
			async presentResponseAlert(type, message) {
				const alert = await alertController
					.create({
						header: type + '!',
						// subHeader: 'Subtitle',
						message: message,
						buttons: ['OK'],
					});
				await alert.present();

			},
			async save() {

				const requireds = [
					'owner_name',
					'owner_address',
					'operate_type',
					'boat_picture',
					'boat_type',
					'engine',
				];
				if (this.postData['operate_type'] == 'Rent') {
					requireds.push(
						'operator_name',
						'operator_address',
						'operator_picture',
					);
				}

				for (const required of requireds) {
					if (this.postData[required] == '' || this.postData[required] == null) {
						let name = required;
						name = name.replace('_id', '');
						name = name.replace('_', ' ');
						this.presentAlert(name);
						return;
					}
				}

				if ((this.postData['ghat']['lat'] == '' || this.postData['ghat']['lat'] == null) || (this.postData[
						'ghat']['lng'] == '' || this.postData['ghat']['lng'] == null)) {
					this.presentAlert('Location');
					return;
				}
				if (this.postData['owner_mobile'].length > 0) {
					for (const i in this.postData['owner_mobile']) {
						if (this.postData['owner_mobile'][i]['mobile'] == '' || this.postData['owner_mobile'][i][
								'mobile'
							] == null) {
							this.presentAlert('Owner mobile');
							return;
						} else if (this.postData['owner_mobile'][i]['mobile'].length != 11) {
							this.presentAlert('Owner Mobile number must be in 11 characters.', true);
							return;
						} else if (["013", "014", "015", "016", "017", "018", "019"].includes(this.postData[
								'owner_mobile'][i]['mobile'].substring(0, 3)) == false) {
							this.presentAlert('Incorrect owner mobile number format.', true);
							return;
						} else if (!Number(this.postData['owner_mobile'][i]['mobile'])) {
							this.presentAlert('Incorrect owner mobile number.', true);
							return;
						}
					}
				}

				if (this.postData['operate_type'] == 'Rent' && this.postData['operator_mobile'].length > 0) {
					for (const i in this.postData['operator_mobile']) {
						if (this.postData['operator_mobile'][i]['mobile'] == '' || this.postData['operator_mobile'][i][
								'mobile'
							] == null) {
							this.presentAlert('Operator mobile');
							return;
						} else if (this.postData['operator_mobile'][i]['mobile'].length != 11) {
							this.presentAlert('Operator mobile number must be in 11 characters.', true);
							return;
						} else if (["013", "014", "015", "016", "017", "018", "019"].includes(this.postData[
								'operator_mobile'][i]['mobile'].substring(0, 3)) == false) {
							this.presentAlert('Incorrect operator mobile number format.', true);
							return;
						} else if (!Number(this.postData['operator_mobile'][i]['mobile'])) {
							this.presentAlert('Incorrect operator mobile number.', true);
							return;
						}
					}
				}
				const data = this.postData;
				if (this.postData['owner_mobile'].length > 0) {
					const temp = [];
					for (const i in this.postData['owner_mobile']) {
						temp.push(this.postData['owner_mobile'][i]['mobile']);
					}
					data['owner_mobile'].length = 0;
					data['ownerMobile'] = temp;
				}

				if (this.postData['operate_type'] == 'Rent' && this.postData['operator_mobile'].length > 0) {
					const temp = [];
					for (const i in this.postData['operator_mobile']) {
						temp.push(this.postData['operator_mobile'][i]['mobile']);
					}
					data['operator_mobile'].length = 0;
					data['operatorMobile'] = temp;
				}
				data['lat'] = this.postData['ghat']['lat'];
				data['lng'] = this.postData['ghat']['lng'];
				data['username'] = window.localStorage.username,
				data['password'] = window.localStorage.password,
				this.$http.post('Boat/Create', data).then(response => {
					if(response.data.status){
						this.presentResponseAlert('success',response.data.message);
						this.ownerImage= null;
						this.nidImage= null;
						this.operatorImage= null;
						this.operatorNidImage= null;
						this.boatImage= null;
						this.segment='Self';
						this.location= null;
						this.postData['owner_name']=null;
						this.postData['owner_mobile']=[{
								mobile: null
							}];
						this.postData['owner_address']=null;
						this.postData['owner_nid']=null;
						this.postData['owner_nid_picture']=null;
						this.postData['owner_picture']=null;
						this.postData['operator_name']=null;
						this.postData['operator_mobile']=[{
								mobile: null
							}];
						this.postData['operator_address']=null;
						this.postData['operator_nid']=null;
						this.postData['operator_nid_picture']=null;
						this.postData['operator_picture']=null;
						this.postData['boat_picture']=null;
						this.postData['boat_type']=null;
						this.postData['operate_type']='Self';
						this.postData['engine']=null;
						this.postData['ghat'] = [{
									lat:null,
									lng:null,
								}];
					}
					// console.log(response);
				}).catch(async (error)=> {
					console.log(error);
				});

				
			},
			async presentAlert(message, fullText = false) {
				const alert = await alertController
					.create({
						header: 'Alert!',
						// subHeader: 'Subtitle',
						message: fullText ? message : message + " is required",
						buttons: ['OK'],
					});
				await alert.present();

			},

			addMoreOwnerMobile() {
				this.postData['owner_mobile'].push({
					mobile: null
				});
			},
			removeOwnerMobile(e) {
				const ex = [];
				for (let i = 0; i < this.postData['owner_mobile'].length; i++) {
					if (i != e) {
						ex.push(this.postData['owner_mobile'][i]);
					}
				}
				this.postData['owner_mobile'] = ex;
			},
			addMoreOperatorMobile() {
				this.postData['operator_mobile'].push({
					mobile: null
				});
			},
			removeOperatorMobile(e) {
				const ex = [];
				for (let i = 0; i < this.postData['operator_mobile'].length; i++) {
					if (i != e) {
						ex.push(this.postData['operator_mobile'][i]);
					}
				}
				this.postData['operator_mobile'] = ex;
			},
			async takePicture(e) {

				const image = await Camera.getPhoto({
					quality: 50,
					height: 720,
					allowEditing: false,
					takePicture: true,
					source: CameraSource.Camera,
					resultType: CameraResultType.Base64,
				});
				if (image) {
					const img = "data:image/jpeg;base64," + image.base64String;
					if (e == 'nid') {
						this.postData["owner_nid_picture"] = image.base64String;
						this.nidImage = img;
					} else if (e == 'owner') {
						this.postData["owner_picture"] = image.base64String;
						this.ownerImage = img;
					} else if (e == 'boat') {
						this.postData["boat_picture"] = image.base64String;
						this.boatImage = img;
					}
					else if(e == 'operatorNid'){
						this.postData["operator_nid_picture"] = image.base64String;
						this.operatorNidImage = img;
					}
					else if(e == 'operator'){
						this.postData["operator_picture"] = image.base64String;
						this.operatorImage = img;
					}
				}
			},

			segmentChanged(event) {
				this.postData['operate_type'] = event.target.value;
			},
			async getGhatLocation() {
				const coordinates = await Geolocation.getCurrentPosition();
				this.postData['ghat']['lat'] = coordinates.coords.latitude;
				this.postData['ghat']['lng'] = coordinates.coords.longitude;
				this.location = 'Lat=' + coordinates.coords.latitude + ', Lng=' + coordinates.coords.longitude;
			}
		},


	}
</script>

<style scoped>
	#container {
		text-align: center;
		position: absolute;
		left: 0;
		right: 0;
		/* top: 50%; */
		/* transform: translateY(-50%); */
	}

	#container strong {
		font-size: 20px;
		line-height: 26px;
	}

	#container p {
		font-size: 16px;
		line-height: 22px;
		color: #8c8c8c;
		margin: 0;
	}

	#container a {
		text-decoration: none;
	}

	.p-dropdown {
		width: 100%;
		color: #000;
	}

	.required {
		color: rgb(233, 0, 0)
	}
</style>